import { render, staticRenderFns } from "./SubmitTool.vue?vue&type=template&id=936610d6&scoped=true"
import script from "./SubmitTool.vue?vue&type=script&lang=js"
export * from "./SubmitTool.vue?vue&type=script&lang=js"
import style0 from "./SubmitTool.vue?vue&type=style&index=0&id=936610d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936610d6",
  null
  
)

export default component.exports